import React, { useEffect } from "react";
import { useWatch } from "react-hook-form";
import GraficaSensorial from "./grafica-sensorial.jsx";
import { ReactHookFormInput } from "../../../nuup/componentes/Forms/ReactHookFormInput.jsx";
const CalidadAnalisisSensorialForm = ({ control, errors, getValues, setValue }) => {
  // Observa únicamente el bloque anidado de análisis sensorial para actualizar la gráfica en vivo
  const sensorValues = useWatch({ control, name: 'analisis_sensorial' });

  useEffect(() => {
    const sv = sensorValues || {};
    const n = (v) => {
      const num = Number(v);
      return isNaN(num) ? 0 : num;
    };
    const sumaAtributos =
      n(sv.fragancia_aroma) +
      n(sv.sabor) +
      n(sv.sabor_residual) +
      n(sv.acidez) +
      n(sv.cuerpo) +
      n(sv.balance) +
      n(sv.taza_limpia) * 2 +
      n(sv.uniformidad) * 2 +
      n(sv.dulzor) * 2 +
      n(sv.catador);
    const defectos = n(sv.defectos_no_tazas) * n(sv.defectos_intensidad);
    const puntajeCalculado = Number((sumaAtributos - defectos).toFixed(2));

    // Evitar ciclos de actualización: solo actualizar si cambió
    const current = getValues && getValues('analisis_sensorial.puntaje_calculado');
    if (setValue && puntajeCalculado !== current) {
      setValue('analisis_sensorial.puntaje_calculado', puntajeCalculado, { shouldDirty: false, shouldValidate: false });
    }
  }, [sensorValues, setValue, getValues]);

  return (
    <>

      <div className="row">
        <div className="col-xs-12 col-md-6 col-xl-6">

          <div className="row mt-3">
            <div className="col-xs-12 col-xl-3">
              <h5>{"Perfil de la taza"}</h5>
            </div>
            <div className="col-md-12 col-xl-9">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.perfil_taza"
                name="analisis_sensorial.perfil_taza"
                label="Descripción"
                error={errors?.analisis_sensorial?.perfil_taza}
                control={control}
                value={getValues()?.analisis_sensorial?.perfil_taza}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3">
              <h5>{"Fragancia / aroma"}</h5>
            </div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.fragancia_aroma"
                name="analisis_sensorial.fragancia_aroma"
                label="Puntuación"
                error={errors?.analisis_sensorial?.fragancia_aroma}
                control={control}
                step={0.25}
                value={getValues()?.analisis_sensorial?.fragancia_aroma}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.fragancia_aroma_desc"
                name="analisis_sensorial.fragancia_aroma_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.fragancia_aroma_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.fragancia_aroma_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3">
              <h5>{"Sabor"}</h5>
            </div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.sabor"
                name="analisis_sensorial.sabor"
                label="Puntuación"
                error={errors?.analisis_sensorial?.sabor}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.sabor}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.sabor_desc"
                name="analisis_sensorial.sabor_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.sabor_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.sabor_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3">
              <h5>{"Sabor residual"}</h5>
            </div>
            <div className="col-xs-4 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.sabor_residual"
                name="analisis_sensorial.sabor_residual"
                label="Puntuación"
                error={errors?.analisis_sensorial?.sabor_residual}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.sabor_residual}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.sabor_residual_desc"
                name="analisis_sensorial.sabor_residual_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.sabor_residual_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.sabor_residual_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Acidez"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.acidez"
                name="analisis_sensorial.acidez"
                label="Puntuación"
                error={errors?.analisis_sensorial?.acidez}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.acidez}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.acidez_desc"
                name="analisis_sensorial.acidez_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.acidez_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.acidez_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Sensación en boca"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.cuerpo"
                name="analisis_sensorial.cuerpo"
                label="Puntuación"
                error={errors?.analisis_sensorial?.cuerpo}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.cuerpo}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.cuerpo_desc"
                name="analisis_sensorial.cuerpo_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.cuerpo_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.cuerpo_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Balance"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.balance"
                name="analisis_sensorial.balance"
                label="Puntuación"
                error={errors?.analisis_sensorial?.balance}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.balance}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.balance_desc"
                name="analisis_sensorial.balance_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.balance_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.balance_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Uniformidad"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.uniformidad"
                name="analisis_sensorial.uniformidad"
                label="No. Tazas"
                error={errors?.analisis_sensorial?.uniformidad}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.uniformidad}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.uniformidad_desc"
                name="analisis_sensorial.uniformidad_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.uniformidad_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.uniformidad_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Taza limpia"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.taza_limpia"
                name="analisis_sensorial.taza_limpia"
                label="No. Tazas"

                error={errors?.analisis_sensorial?.taza_limpia}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.taza_limpia}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.taza_limpia_desc"
                name="analisis_sensorial.taza_limpia_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.taza_limpia_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.taza_limpia_desc}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Dulzor"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.dulzor"
                name="analisis_sensorial.dulzor"
                label="No. Tazas"
                error={errors?.analisis_sensorial?.dulzor}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.dulzor}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.dulzor_desc"
                name="analisis_sensorial.dulzor_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.dulzor_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.dulzor_desc}
              />
            </div>
          </div>

          {/* Bloque de Defectos entre Dulzor y Catador */}
          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Defectos"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.defectos_no_tazas"
                name="analisis_sensorial.defectos_no_tazas"
                label="No. tazas"
                error={errors?.analisis_sensorial?.defectos_no_tazas}
                control={control}
                step={1}
                value={getValues()?.analisis_sensorial?.defectos_no_tazas}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.defectos_intensidad"
                name="analisis_sensorial.defectos_intensidad"
                label="Intensidad"
                error={errors?.analisis_sensorial?.defectos_intensidad}
                control={control}
                step={2}
                value={getValues()?.analisis_sensorial?.defectos_intensidad}
              />
            </div>
          </div>


          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Catador"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">
              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.catador"
                name="analisis_sensorial.catador"
                label="Puntuación"
                error={errors?.analisis_sensorial?.catador}
                control={control}
                step="0.25"
                value={getValues()?.analisis_sensorial?.catador}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6">
              <ReactHookFormInput
                type="text"
                id="analisis_sensorial.catador_desc"
                name="analisis_sensorial.catador_desc"
                label="Descripción"
                error={errors?.analisis_sensorial?.catador_desc}
                control={control}
                value={getValues()?.analisis_sensorial?.catador_desc}
              />
            </div>
          </div>


          {/* Puntajes */}
          <div className="row mt-3">
            <div className="col-xs-12 col-md-12 col-xl-3 col-xxl-3"><h5>{"Puntaje en taza"}</h5></div>
            <div className="col-xs-12 col-xl-4 col-xxl-3">

              <ReactHookFormInput
                type="number"
                id="analisis_sensorial.puntaje_manual"
                name="analisis_sensorial.puntaje_manual"
                label="Puntuación"
                error={errors?.analisis_sensorial?.puntaje_manual}
                control={control}
                step={0.25}
                value={getValues()?.analisis_sensorial?.puntaje_manual}
              />
            </div>
            <div className="col-xs-12 col-md-8 col-xl-5 col-xxl-6" style={{marginTop: '10px'}}>
                {getValues()?.analisis_sensorial?.puntaje_calculado > 0 && (<span style={{fontSize: '0.875rem', color: 'black',fontWeight: 'bold'}}>Puntaje calculado: {getValues()?.analisis_sensorial?.puntaje_calculado}</span>)}
            </div>
          </div>


        </div>
        <div className="col-xs-12 col-md-6 col-xl-6">
          <GraficaSensorial data={sensorValues || {}} />
        </div>
      </div>

      {/* Envío se realiza desde el botón Continuar del padre */}
    </>
  );
};

export default CalidadAnalisisSensorialForm;